/**
 * save-amount-badge.js
 *
 * Pairs with the customised badges.liquid which renders sale badges as:
 *   <hdt-badge is="on_sale" data-save-threshold="10" ...>Save <span save-amount>£10</span></hdt-badge>
 *
 * The badge prefers showing "Save £X" once the saving meets the threshold.
 * Below the threshold it falls back to a percentage so small savings still feel meaningful.
 *
 * Hardcoded to GBP. If you ever need multi-currency, replace the formatter.
 * The threshold is read from the badge's data-save-threshold attribute, with
 * SAVE_THRESHOLD_FALLBACK used if the attribute is missing.
 */
(function () {
  var SAVE_THRESHOLD_FALLBACK = 10;

  function formatBadgeText(variant, threshold) {
    if (!(variant.compare_at_price > variant.price)) return '';
    var savedCents = variant.compare_at_price - variant.price;
    var savedPounds = Math.floor(savedCents / 100);
    if (savedPounds >= threshold) {
      return '\u00A3' + savedPounds;
    }
    var percent = Math.max(1, Math.round((savedCents / variant.compare_at_price) * 100));
    return percent + '%';
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var formId = e.target && e.target.id;
    if (!formId) return;

    var selector =
      'hdt-badge[is="on_sale"][form="' + formId + '"], ' +
      'hdt-badge[is="on_sale"]:not([form])';
    var badges = document.querySelectorAll(selector);

    badges.forEach(function (badge) {
      var saveEl = badge.querySelector('[save-amount]');
      if (!saveEl) return;

      var threshold = parseInt(badge.getAttribute('data-save-threshold'), 10);
      if (isNaN(threshold)) threshold = SAVE_THRESHOLD_FALLBACK;

      saveEl.textContent = formatBadgeText(variant, threshold);
    });
  });
})();